import { PublicRoutesConfig } from "./config";

const defineAppRouteMap = <T extends Record<string, string | undefined>>(
  config: T,
): { [K in keyof T]: string | undefined } => config;

export const APP_ROUTE_MAP = defineAppRouteMap({
  website: PublicRoutesConfig.NEXT_PUBLIC_WEBSITE_URL,
  customerPortal: PublicRoutesConfig.NEXT_PUBLIC_CUSTOMER_PORTAL_URL,
  funnel: PublicRoutesConfig.NEXT_PUBLIC_FUNNEL_URL,
  adminPortal: PublicRoutesConfig.NEXT_PUBLIC_ADMIN_PORTAL_URL,
  thirdParty: "",
});
